import { gsap } from "gsap";

class UmQuesForm extends HTMLElement {
   constructor() {
      super();
      // this.attachShadow({ mode: 'open' });

      this.id = this.getAttribute('id')

      this.textarea = this.querySelector('textarea')
      this.submitBtn = this.querySelector('um-button')
   }

    connectedCallback() {
      // this.querySelector(".button").addEventListener("click", this.handleButtonClick.bind(this));

      this.submitBtn.clickEvent = () => {
        this.handleSubmit()
      }
    }

    handleButtonClick(e) {
      if (!this.clickEvent) {
        return
      }
      e.preventDefault()
      if (this.clickEvent) {
        this.clickEvent()
      }

    }

    handleSubmit() {
      // console.log(this.textarea.value);
      let ans = this.textarea.value

      if (!ans) {
        return
      }

      ans = ans.replace(/\r?\n/g, '<br />');
      const url = `${window.location.origin}?api=quesAns&ques=${this.id}&ans=${ans}`
      fetch(url)
      .then(response => response.text())
      .then((data) => {
        const res = JSON.parse(data)

        const c_label = document.createElement('label');
        c_label.innerHTML = res.c_label;

        const c_content = document.createElement('p');
        c_content.innerHTML = ans;

        const d_label = document.createElement('label');
        d_label.innerHTML = res.d_label;

        const d_content = document.createElement('div');
        d_content.innerHTML = res.d_content;

        this.querySelector('.client_answer--wrap').append(c_label, c_content);
        this.querySelector('.default_answer--wrap').append(d_label, d_content);


        gsap.set(this.querySelector('.info'), {
          position: 'absolute'
        })

        gsap.set(this.querySelector('.answers'), {
          position: 'relative'
        })

        gsap.to(this.querySelector('._wrap'), {
          height: this.querySelector('.answers').offsetHeight,
          duration: 5,
          onComplete: () => {
            gsap.set(this.querySelector('._wrap'), {
              height: 'auto'
            })
          }
        })

        gsap.to(this.querySelector('.info'), {
          left: '-100%',
          opacity: 0,
        })

        gsap.to(this.querySelector('.answers'), {
          left: '0%',
          opacity: 1,
        })
      });


    }

}

customElements.define('um-ques-form', UmQuesForm);
